module.exports = __webpack_public_path__ + "media/images/area/feature/banner/pc/ja_tohoku-d3162bec98edff076e6b17b5f37e5621.jpg";